import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { DistributionRun, GenerateDistributionRequest } from '../../models/distribution.model';

/**
 * Client for the distribution run engine (/api/distributions).
 */
@Injectable({ providedIn: 'root' })
export class DistributionService {
  private baseUrl = `${environment.apiUrl}/api/distributions`;

  constructor(private http: HttpClient) {}

  list(): Observable<DistributionRun[]> {
    return this.http.get<DistributionRun[]>(this.baseUrl);
  }

  get(id: number): Observable<DistributionRun> {
    return this.http.get<DistributionRun>(`${this.baseUrl}/${id}`);
  }

  generate(body: GenerateDistributionRequest): Observable<DistributionRun> {
    return this.http.post<DistributionRun>(this.baseUrl, body);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }

  rerun(id: number): Observable<DistributionRun> {
    return this.http.post<DistributionRun>(`${this.baseUrl}/${id}/rerun`, {});
  }

  approve(id: number): Observable<DistributionRun> {
    return this.http.put<DistributionRun>(`${this.baseUrl}/${id}/approve`, {});
  }

  finalize(id: number): Observable<DistributionRun> {
    return this.http.post<DistributionRun>(`${this.baseUrl}/${id}/finalize`, {});
  }

  summaryPdf(id: number): Observable<Blob> {
    return this.http.get(`${this.baseUrl}/${id}/report.pdf`, { responseType: 'blob' });
  }

  collectorPdf(id: number): Observable<Blob> {
    return this.http.get(`${this.baseUrl}/${id}/collector-report.pdf`, { responseType: 'blob' });
  }
}
